import HttpService from './HttpService';

const NotificationService = {
  /**
   * Get all notifications for the current user
   * @param {string} type - Optional filter by type ('notification' or 'alert')
   * @returns {Promise<Object>} - Response containing notifications array
   */
  async getNotifications(type = '') {
    try {
      const urlSuffix = type 
        ? `WebNotification/GetNotifications?type=${type}`
        : 'WebNotification/GetNotifications';
      
      const response = await HttpService.get(urlSuffix);
      return response;
    } catch (error) {
      console.error('Error fetching notifications:', error);
      throw error;
    }
  },

  /**
   * Mark a notification as read
   * @param {number} notificationId - The ID of the notification to mark as read
   * @returns {Promise<Object>} - Response from the API
   */
  async markAsRead(notificationId) {
    try {
      const response = await HttpService.post(
        `WebNotification/MarkAsRead/${notificationId}`,
        {}
      );
      return response;
    } catch (error) {
      console.error('Error marking notification as read:', error);
      throw error;
    }
  },

  /**
   * Get alerts (banner notifications)
   * @returns {Promise<Object>} - Response containing alerts array
   */
  async getAlerts() {
    try {
      const response = await HttpService.get('WebNotification/GetAlerts');
      return response;
    } catch (error) {
      console.error('Error fetching alerts:', error);
      throw error;
    }
  },
};

export default NotificationService;
